export default {
    methods: {
        getLatexText(text){
           text=text+"";

            if(text!=null && text!=undefined && text!=''){
                // console.log("NOTEMPTY");
                if(text.includes('\\\(')){
                    // var array=this.indexesOf(text, /(\\\())/g);
                    // text= text.replace(/\\(?!\()/g, '\\\\');
                    // text= text.replace(/\\\\\)/g, '\\)');
                    text = text.split("\\\(").join("\(");
                    // text= text.replace(/\\(?!\))/g, '\\\\');
                    // console.log(array);
                    
                }
                if(text.includes('\\\)')){
                    // var array=this.indexesOf(text, /(\\\())/g);
                    // text= text.replace(/\\(?!\()/g, '\\\\');
                    // text= text.replace(/\\\\\)/g, '\\)');
                    text = text.split("\\\)").join("\)");
                    // text= text.replace(/\\(?!\))/g, '\\\\');
                    // console.log(array);
                    
                }
                // if(text.includes("$$")){
                //     console.log(text);
                //     console.log("$$$$$$$$$$$$$$$$$$$");
                // }
                // else{
                //     console.log(text);
                //     var regex = /\$/g;
                //     var current;
                //     var matchIndexes = [];

                //     while ((current = regex.exec(text)) != null)
                //     {
                //         matchIndexes.push(current.index);
                //     }
                //     console.log(matchIndexes);
                // }
                // console.log("****************");
                // console.log(text);
                // console.log("\(7^{\\sqrt[3]{4}}; \) \(7^{\\sqrt[4]{5}}\);\( 7^{\\sqrt{3}}\) тоонуудыг буурах дарааллаар эрэмбэл"==text);
                return text;
            }
            return "";
        },
        stringEscape(s) {
            return s ? s.replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/\t/g,'\\t').replace(/\v/g,'\\v').replace(/'/g,"\\'").replace(/"/g,'\\"').replace(/[\x00-\x1F\x80-\x9F]/g,hex) : s;
            function hex(c) { var v = '0'+c.charCodeAt(0).toString(16); return '\\x'+v.substr(v.length-2); }
        },
        
        isLatex(text){
            text=text+"";
            if(text!=null && text!=undefined && text!=''){
                if(text.includes("$") || text.includes("$$") || text.includes("\(") || text.includes("\)" || text.includes("<p>") || text.includes("\\")))
                    return true;
            }
            return false;
        },
        indexesOf(string, regex) {
            var match,
                indexes = {};
        
            regex = new RegExp(regex);
        
            while (match = regex.exec(string)) {
                if (!indexes[match[0]]) indexes[match[0]] = [];
                indexes[match[0]].push(match.index);
            }
        
            return indexes;
        },
        
    }
}